<template>
  <div class="user-list">
    <!-- 系统管理-用户管理（企业微信手机端，仅查看） -->
    <mobile-list-header>
      <div class="search-bar">
        <div class="search-input">
          <yq-icon class="icon" name="element-ui_search"/>
          <input v-model="searchInfo.searchKey" placeholder="用户名称/联系方式" @keyup.enter="resetSearch"/>
          <yq-icon v-if="searchInfo.searchKey" class="icon clear" name="element-ui_close" @click="clearKey"/>
        </div>
        <div class="search-btn" @click="resetSearch">搜索</div>
      </div>
      <div class="filter-row">
        <mobile-condition-select v-model="searchInfo.departCode" :data="departTree"
                                 label-column="departName" code-column="departCode" type="tree"
                                 placeholder="部门" @change="resetSearch"/>
        <mobile-condition-select v-model="searchInfo.roleId" :data="roleList"
                                 label-column="roleName" code-column="id" type="list"
                                 placeholder="角色" @change="resetSearch"/>
      </div>
    </mobile-list-header>

    <mobile-list :loading="loading" :has-more="searchInfo.hasMore" :query-list="queryList"
                 :refresh="resetSearch" ref="mobileList">
      <list-card class="user-item" v-for="item in dataList" :key="item.id" :label="item.employeeName"
                 @click="toDetail(item)">
        <template #desc>
          <span class="status-tag" :class="Number(item.status) === 1 ? 'on' : 'off'">
            {{ Number(item.status) === 1 ? "正常" : "禁用" }}
          </span>
          <yq-icon class="item-arrow" name="element-ui_arrow-right"/>
        </template>
        <data-column label="联系方式">{{ item.employeePhone || "—" }}</data-column>
        <data-column label="邮件地址">{{ item.emailAddress || "—" }}</data-column>
        <data-column label="部门名称">{{ departNames(item) || "—" }}</data-column>
        <data-column label="角色名称">{{ roleNames(item) || "—" }}</data-column>
        <data-column label="最近登录">{{ item.lastLogin || "—" }}</data-column>
      </list-card>
    </mobile-list>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import MobileList from "@/components/qywx/layout/MobileList.vue";
import MobileListHeader from "@/components/qywx/layout/MobileListHeader.vue";
import MobileConditionSelect from "@/components/qywx/data/MobileConditionSelect.vue";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import YqIcon from "@/components/YqIcon.vue";
import employeeApi from "@/api/normal/sys/employeeApi";
import commonApi from "@/api/commonApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "UserListQW",
  components: {
    YqIcon, DataColumn, ListCard, MobileConditionSelect, MobileListHeader, MobileList
  },
  data() {
    return {
      loading: false,
      searchInfo: {
        searchKey: "",
        departCode: "",
        roleId: "",
        pageNumber: 0,
        pageSize: 20,
        hasMore: true, // 初始为 true，列表挂载后由无限滚动自动触发首次查询
      },
      dataList: [],
      roleList: [],
      departTree: [],
    };
  },
  created() {
    employeeApi.queryAllRoles().then(list => this.roleList = list || []);
    commonApi.queryDepartList().then(list => this.departTree = list || []);
  },
  methods: {
    queryList() {
      this.loading = true;
      this.searchInfo.pageNumber++;
      const params = {
        pageNumber: this.searchInfo.pageNumber,
        pageSize: this.searchInfo.pageSize,
      };
      ["searchKey", "departCode", "roleId"].forEach(key => {
        if (this.searchInfo[key] !== "" && this.searchInfo[key] !== null && this.searchInfo[key] !== undefined) {
          params[key] = this.searchInfo[key];
        }
      });
      employeeApi.queryList(params).then(res => {
        this.dataList = this.dataList.concat(res.records || []);
        this.searchInfo.hasMore = res.pageCount > this.searchInfo.pageNumber;
        this.loading = false;
        this.$refs.mobileList.hideRefreshTitle();
      }).catch(() => {
        this.loading = false;
      })
    },
    resetSearch() {
      this.searchInfo.pageNumber = 0;
      this.dataList = [];
      this.searchInfo.hasMore = true;
      this.queryList();
    },
    clearKey() {
      this.searchInfo.searchKey = "";
      this.resetSearch();
    },
    departNames(item) {
      return (item.departList || []).map(d => d.departName).filter(name => name).join("、");
    },
    roleNames(item) {
      return (item.roleList || []).map(r => r.roleName).filter(name => name).join("、");
    },
    toDetail(item) {
      this.router.push(`/qywx/sys/user/detail?id=${item.id}`);
    },
  }
};
</script>

<style lang="scss" scoped>
.user-list{
  height: 100%;
  display: flex;
  flex-direction: column;
}
.search-bar{
  display: flex;
  align-items: center;
  height: 44px;
  padding-left: 12px;
  border-radius: 999px;
  background: var(--yq-background-color);
  overflow: hidden;
  .search-input{
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
    height: 100%;
    padding-right: 12px;
    .icon{
      flex: none;
      color: var(--yq-font-color-desc);
      font-size: var(--yq-font-size-mini-mobile);
      &.clear{
        margin-left: 6px;
      }
    }
    input{
      flex: 1;
      min-width: 0;
      height: 100%;
      margin-left: 6px;
      border: none;
      outline: none;
      background: transparent;
      font-size: var(--yq-font-size-mini-mobile);
      color: var(--yq-font-color-base);
      &::placeholder{
        color: var(--yq-font-color-desc);
      }
    }
  }
  .search-btn{
    flex: none;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 18px;
    background: var(--el-color-primary);
    color: #FFF;
    font-size: var(--yq-font-size-mini-mobile);
  }
}
.filter-row{
  display: flex;
  gap: 18px;
  margin-top: 10px;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar{
    display: none;
  }
  > *{
    flex: none;
  }
}
.user-item{
  :deep(.card-title .desc){
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .status-tag{
    flex: none;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: var(--yq-font-size-mini-mobile);
    &.on{
      color: var(--el-color-success);
      background: var(--el-color-success-light-9);
    }
    &.off{
      color: var(--el-color-info);
      background: var(--el-fill-color-light);
    }
  }
  .item-arrow{
    color: var(--yq-font-color-desc);
    font-size: var(--yq-font-size-mini-mobile);
  }
}
</style>
